import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'EmbedInfo'; // Adjust the URL based on your actual API's URL

const getWorkspaces = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Groups`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch workspaces:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const getReportsFromWorkspace = async (workspaceId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Reports/${workspaceId}`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch reports:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

const getReportEmbeddingDetails = async (groupId, reportId) => {
    try {
        const config = {
            params: {
                groupId, reportId
            }
        }
        const response = await axios.get(`${API_BASE_URL}`, config);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch report embedding details:', error);
        throw error; // Re-throw the error for handling by the caller
    }
};

export const ReportsDataService = {
    getWorkspaces,
    getReportsFromWorkspace,
    getReportEmbeddingDetails
};
